import { parceBudget } from './parceBudget';

const isInvalidAmount = raw => {
  if (raw === '' || raw === null || raw === undefined) return false;
  const numeric = Number(String(raw).replace(/,/g, ''));
  if (Number.isNaN(numeric)) return true;
  return numeric === 0 || numeric > 1000000000;
};

const sanitizeAmountInput = value => String(value).replace(/,/g, '');
const formatAmountForInput = amount => {
  if (amount === '' || amount === null || amount === undefined) return '';
  if (Number(amount) >= 0) return parceBudget(amount, '', 0);
  return '';
};

export { isInvalidAmount, sanitizeAmountInput, formatAmountForInput };
